import React, { useRef, useEffect, useState } from "react"
import { Tabs, Tab, Box } from '@mui/material';
import SampleGraphContainer from './SampleGraphContainer'
import CompetitiveAnalysis from './competitive-analysis/CompetitiveAnalysis'
import MoreDataForm from './MoreDataForm'
import VisualizationSelector from './visualizationPanel/components/VisualizationSelector'
import NowcastingVisualization from './visualizationPanel/components/NowcastingVisualization'
import styles from './visualizationPanel/components/ResearchSection.module.scss'
import './Graphs.css'
import { useGeneral } from "../context/general";

function TabContent (props) {
    const { children, value, index, ...other } = props
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
            >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    )
}

function usePrevious(value) {
    const ref = useRef()
    // useEffect(() =>{ ref.current = value;return () =>{}})
    useEffect(() =>{ ref.current = value})
    // return () => ref.current
    return ref.current
}

export default function Graphs({ dataset, ticker, financialInfo, analyze, sectionId, tab, setTab, projectId}) {
    const { projectTickerData } = useGeneral()
    const prevAnalyze = usePrevious(analyze)
    const [moreDataFormVisibility, setMoreDataFormVisibility] = useState(false)

    const handleChange = (event, newValue) => {
        setTab(newValue)
    }

    const graphProps = { responsive: true, dataset, ticker, financialInfo, analyze, sectionId }
    
    const renderOverview = () => (
        <div>
            <VisualizationSelector ticker={ticker}/>
            <SampleGraphContainer {...graphProps} prevAnalyze={prevAnalyze} /> 
        </div>
    )

    const renderNowcasting = () => (
        <div>
            <NowcastingVisualization ticker={ticker} sectionId={sectionId} projectId={projectId}/>
        </div>
    )

    const renderCompetitiveAnalysis = () => (
        <div>
            <CompetitiveAnalysis ticker={ticker} dataset={dataset} sectionId={sectionId}/>
        </div>
    )

    // const TABS = projectTickerData?.nowcasting?[
    //     { label: 'Main' , render: renderOverview },
    //     { label: 'Nowcasting' , render: renderNowcasting },
    //     { label: 'Competitive Analysis', render: renderCompetitiveAnalysis }
    // ]:[
    //     { label: 'Main' , render: renderOverview },
    //     { label: 'Competitive Analysis', render: renderCompetitiveAnalysis }
    // ]

    const TABS = [
        { label: 'Main' , render: renderOverview },
        { label: 'Nowcasting' , render: renderNowcasting },
        { label: 'Competitive Analysis', render: renderCompetitiveAnalysis }
    ]

    const openMoreDataForm = () => {
        setMoreDataFormVisibility(true)
    } 

    return (
        <div className={styles['content-padding']}>
            <div className='tabs'>
                <Tabs value={tab} onChange={handleChange} textColor='inherit' classes={{ indicator: styles['indicator'] }}>
                    { TABS.map(({label}, i) => (<Tab label={label} value={i} key={label} classes={{ root: styles['tab'], selected: styles['selected'] }} />)) }
                </Tabs>
                <p className='contact-us-p' onClick={openMoreDataForm}>Data Questions</p>
            </div>
                { TABS.map(({render, label}, i) => <TabContent value={tab} index={i} key={label}>{render()}</TabContent>) }
                <MoreDataForm open={moreDataFormVisibility} setMoreDataFormVisibility={setMoreDataFormVisibility}/>
        </div>
    )
}
